import React from 'react'
import CustomLinkComponent from '@atoms/CustomLink/CustomLinkComponent'
import Icons from '@atoms/Icons/Icons'

const GooglePlayStoreCustomLink = ({
  url,
  className
}: {
  url?: string
  className?: string
}) => (
  <CustomLinkComponent
    href={url || '#'}
    className={className}
    colorScheme='whiteAlpha'
    uppercase={false}
    isExternalLink
    openInNewTab
    rel='nofollow'
  >
    <div className='fill-white'>
      <Icons iconName='GoogleAppStore' width='108px' height='32px' />
    </div>
  </CustomLinkComponent>
)

export default GooglePlayStoreCustomLink
